import axios from 'axios';
import { withPimURL } from '../../../helpers/service';
import { UserModel } from '../models/UserModel';

const API_URL = process.env.REACT_APP_API_URL || 'api';
const AUTH_URL = process.env.REACT_APP_API_AUTH_LOGIN_URL;
const FORGOT_URL = process.env.REACT_APP_API_AUTH_FORGOT_URL;
const FORGOT_REQUEST = process.env.REACT_APP_API_AUTH_FORGOT_REQUEST;
const PLATFORM = process.env.REACT_APP_PLATFORM;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/get-user`;
export const LOGIN_URL = `${AUTH_URL}`;
export const RESEND_SMS_URL = process.env.REACT_APP_API_AUTH_RESEND_SMS_URL;
export const VALIDATE_SMS_URL = process.env.REACT_APP_API_AUTH_VALIDATE_SMS_URL;
export const LOCK_SMS_URL = `${process.env.REACT_APP_API_AUTH_URL}/vendor-otp`;
export const LOCK_VALIDATE_SMS_URL = `${process.env.REACT_APP_API_AUTH_URL}/vendor-otp-validate`;
export const REQUEST_PASSWORD_URL = `${FORGOT_REQUEST}`;
export const REQUEST_CHANGE_PASSWORD_URL = `${FORGOT_URL}`;

// Server should return AuthModel
export async function login(email: string, password: string) {
  const { headers, ip = '' } = await axios.get(withPimURL('/vendor/my-ip')).then((res) => res.data);
  const clientIp = headers?.['client-ip']?.[0] || ip || '';

  return axios.post(LOGIN_URL, { userName: email, password: password, platform: PLATFORM, clientIp: ip });
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(values: any) {
  const body = values?.isSMS ? { phone: values?.phone?.value, platform: PLATFORM, type: 'sms' } : { userName: values?.email, platform: PLATFORM, type: 'email' };
  return axios.post(REQUEST_PASSWORD_URL, body);
}

export function requestNewPassword(password: string, passwordRenewalFrequency: number, hash: string) {
  return axios.post(REQUEST_CHANGE_PASSWORD_URL + `/${hash}`, { password, passwordRenewalFrequency });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL);
}
